import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = "Confirmação",
  message = "Deseja realmente realizar esta ação?",
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="success" autoFocus>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
